import React, { useState, useEffect, useCallback } from 'react';
import { Box } from '@material-ui/core';
import { motion, AnimatePresence } from 'framer-motion';

import useStyles from './styles';

const variants = {
  enter: direction => ({
    x: direction > 0 ? 1000 : -1000,
    opacity: 0,
  }),
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
  exit: direction => ({
    zIndex: 0,
    x: direction < 0 ? 1000 : -1000,
    opacity: 0,
  }),
};

const transition = {
  x: { type: 'spring', stiffness: 70, damping: 40 },
  opacity: { duration: 0.3 },
};

const SliderWindow = ({ children, goTo, className }) => {
  const [[page, direction], setPage] = useState([0, 0]);
  const [isAnimating, setIsAnimating] = useState(false);

  const classes = useStyles({ isAnimating });

  const paginate = useCallback(newDirection => {
    setPage(([oldPage]) => [oldPage + newDirection, newDirection]);
  }, []);

  useEffect(() => {
    paginate(goTo);
  }, [paginate, goTo]);

  return (
    <Box className={classes.container}>
      <AnimatePresence initial={false} custom={direction}>
        <motion.div
          key={page}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={transition}
          className={`${className} slide-wrapper`}
          onAnimationStart={() => setIsAnimating(true)}
          onAnimationComplete={() => setIsAnimating(false)}
        >
          {children.map((slide, index) => index === page && slide)}
        </motion.div>
      </AnimatePresence>
    </Box>
  );
};

export default SliderWindow;
